import React from "react";
import { Button, Box } from "@mui/material";
import { theme } from "../../muiTheme";
import { dropDownButtonStyle } from "./dropdownButtonStyle";

const LabelButton = ({
  type = "primary",
  variant = "contained",
  shape = "rectangle",
  disabled = false,
  disableElevation = false, //a boolean to control the shadow effect
  disableButtonStyle = {}, //optional, a specific style that different from the defautl disable format
  ...props
}) => {
  return (
    <Button
      variant={variant}
      disabled={disabled}
      onClick={props.function}
      disableElevation={disableElevation}
      sx={{
        border: dropDownButtonStyle[type][variant]["default"].border,
        borderRadius: dropDownButtonStyle.borderRadius[shape],
        backgroundColor:
          dropDownButtonStyle[type][variant]["default"].backgroundColor,
        padding: "5px 20px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        width: "100%",
        height: "100%",
        minWidth: 0,
        color: dropDownButtonStyle[type][variant]["default"].color,
        "& .MuiButton-startIcon, & .MuiButton-endIcon": {
          margin: 0,
        },
        "&:hover": {
          border: dropDownButtonStyle[type][variant].hover.border || "none",
          backgroundColor:
            dropDownButtonStyle[type][variant].hover.backgroundColor,
          "& .label-text": {
            color: dropDownButtonStyle[type][variant].hover.color,
          },
          "& .button-icon": {
            color: dropDownButtonStyle[type][variant].hover.color,
          },
        },
        "&:disabled": {
          border: dropDownButtonStyle[type][variant].disabled.border || "none",
          backgroundColor:
            dropDownButtonStyle[type][variant].disabled.backgroundColor,
          opacity: dropDownButtonStyle[type][variant].disabled.opacity,
          ...disableButtonStyle,
          "& .label-text": {
            color: disableButtonStyle.color || dropDownButtonStyle[type][variant].disabled.color,

          },
          "& .button-icon": {
            color: dropDownButtonStyle[type][variant].disabled.color,
          },
        },
      }}>
      <Box sx={{ display: "flex", alignItems: "center" }}>
        {props.leftIcon && (
          <props.leftIcon
            className="button-icon"
            fontSize={props.iconSize || "small"}
          />
        )}
      </Box>
      <Box
        className="label-text"
        sx={{
          flexGrow: 1,
          textAlign: "center",
          ...theme.dropdownButton.font,
          textTransform: "none",
          color: dropDownButtonStyle[type][variant]["default"].color,
        }}>
        {props.text}
      </Box>
      <Box sx={{ display: "flex", alignItems: "center" }}>
        {props.rightIcon && (
          <props.rightIcon
            className="button-icon"
            fontSize={props.iconSize || "small"}
          />
        )}
      </Box>
    </Button>
  );
};

export default LabelButton;
